import React, { type ReactNode } from 'react';
import { AuthContext, AuthProvider as SharedAuthProvider, useAuth } from '@gastrosoft/shared/auth';
import { authClient } from './authClient';
import { tokenManager } from '@/app/services/tokenManager';

export { AuthContext, useAuth };

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => (
  <SharedAuthProvider authClient={authClient} tokenManager={tokenManager}>
    {children}
  </SharedAuthProvider>
);
